<template>
  <div>
    <router-link :to="{ name: 'help-center', query: { module: 'trade' } }">
      <Row chevron has-interaction class="link" @click="onHandleClick">
        <template #icon-left>
          <InitialAvatarIcon
            class="help-center__icon"
            icon="AA0010"
            size="medium"
            aria-hidden="true"
          />
        </template>
        <template #top-left>Me ajuda</template>
      </Row>
    </router-link>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Vue } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { Row, InitialAvatarIcon } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    Row,
    InitialAvatarIcon
  }
})
export default class HelpButton extends Vue {
  get NebraskaColors() {
    return NebraskaColors;
  }

  @Emit('handle-click-help')
  onHandleClick() {}
}
</script>

<style lang="less" scoped>
.help-center {
  &__icon {
    color: @element-primary;
    background: @background-tertiary;
  }
}
</style>
